import { render, staticRenderFns } from "./VoiceAgentKnowledgeBaseCreated.vue?vue&type=template&id=0d6196f4"
import script from "./VoiceAgentKnowledgeBaseCreated.vue?vue&type=script&lang=js"
export * from "./VoiceAgentKnowledgeBaseCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports